import React from 'react'

function Paper() {
  return (
    <div>
            {/* <p className='header_Problem'>View related works from our group</p>
            <p> &#9679; {''}      I will display </p> */}
      
    </div>
  )
}

export default Paper
